import { cn } from "@/modules/lib/utils"
import { Article } from "@modules/article/entities/articleEntity"
import { HUPortableText } from "@modules/common/cms/components/huPortableText"
import { word } from "@modules/core/utils/i18n"
import { LoadingSpinner } from "@modules/ui/components/loading"
import dayjs from "dayjs"
import styled from "styled-components"
import { Text } from "@/components/ui/baseUi/text"

type ArticleResumeProps = {
  article: Article
} & React.ComponentProps<"div">

export function ArticleResume({ article, className, ...props }: ArticleResumeProps) {
  if (!article) return <LoadingSpinner />

  return (
    <div className={cn("flex w-full flex-col pb-4", className)} {...props}>
      {/* HEADER */}
      <div className="relative flex justify-center">
        <CategoryTag>
          <Text fontStyle="LL" className="text-textOnColor-body">
            {word(`article.tag.${article.tag}`)}
          </Text>
        </CategoryTag>

        <ImageContainer
          $bgImage={article.thumbnail.uri}
          className="relative flex h-72 w-full flex-row items-center justify-center gap-2 overflow-hidden rounded-b-4xl bg-cover bg-center p-5"
        >
          <GradientOverlay />
          <TitleContainer>
            <div className="flex flex-row items-center gap-2">
              <Text fontStyle="HS" className="text-textOnColor-heading">
                {article.title}
              </Text>
            </div>
          </TitleContainer>
        </ImageContainer>
      </div>

      {/* CONTENT */}
      <div className="flex flex-col p-5">
        <Text fontStyle="BS" className="mb-2.5">
          {word("article.author_infos", {
            date: dayjs(article._createdAt).format("LL"),
            author: article.author,
          })}
        </Text>

        <div className="mt-4 px-4">
          <HUPortableText value={article.content} />
        </div>
      </div>
    </div>
  )
}

const ImageContainer = styled.div<{ $bgImage?: string }>`
  background-image: ${({ $bgImage }) => `url(${$bgImage})`};
`
const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(34, 34, 34, 0) 0%, rgba(34, 34, 34, 0.8) 99.9%);
  border-radius: 33px;
  border-width: 0px;
  height: 290px;
  width: 100%;
`
const TitleContainer = styled.div`
  position: absolute;
  bottom: 30px;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0px 30px;
  text-align: center;
`
const CategoryTag = styled.div`
  position: absolute;
  top: 45px;
  left: 20px;
  border-radius: 44px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(7px);
  padding: 9px 12px 8px 12px;
  min-width: 80px;
  display: flex;
  justify-content: center;
  z-index: 2;
`
